import React, { useEffect, useState } from "react";
import { NavLink, withRouter } from "react-router-dom"; // v4/v5 compatible

/**
 * BlogSideBarRight — polished blog sidebar
 * - Sticky container
 * - Search (pushes to /search?q=...)
 * - Popular Reads (clean list-group)
 * - Quick Topics (chips that route to search by topic)
 * - Optional AdSense slot
 * - Newsletter CTA
 * - Contact/Write for us
 * Uses only Bootstrap 5 classes; no Bootstrap JS.
 */

// Optional AdSense slot (replace ids or remove if not using AdSense yet)
function AdSlot({ adSlot = "5201219465" }) {
  useEffect(() => {
    try {
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        window.adsbygoogle.push({});
      }
    } catch {}
  }, []);

  return (
    <div className="my-3">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9033879555371063"
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

const POPULAR = [
  { to: "/consul", title: "What is Consul?" },
  { to: "/cdn", title: "Why is a CDN Popular?" },
  { to: "/git", title: "Let’s Understand Git" },
  { to: "/projects", title: "Sample Projects for You" },
  { to: "/cache", title: "What is a Cache?" },
  { to: "/blind75", title: "Must‑Know 75 Coding Interview Questions" },
];

const TOPICS = [
  "Git",
  "Service Mesh",
  "CDN",
  "Caching",
  "Interview",
  "Career",
  "Projects",
];

function BlogSideBarRight({ history, className = "", style = {} }) {
  const [query, setQuery] = useState("");

  const onSearch = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q) history.push(`/search?q=${encodeURIComponent(q)}`);
  };

  const onTopicClick = (topic) => {
    history.push(`/search?q=${encodeURIComponent(topic)}`);
  };

  return (
    <aside
      className={`sidebar-right ${className}`}
      style={{ position: "sticky", top: "1rem", alignSelf: "flex-start", ...style }}
      aria-label="Blog right sidebar"
    >
      {/* Search */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Search</h2>
          <form className="d-flex" onSubmit={onSearch} role="search" aria-label="Blog search">
            <input
              type="search"
              className="form-control form-control-sm me-2"
              placeholder="Search articles…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              aria-label="Search articles"
            />
            <button className="btn btn-primary btn-sm" type="submit">Go</button>
          </form>
        </div>
      </div>

      {/* Popular Reads */}
      <nav className="card shadow-sm border-0 mb-3" aria-labelledby="popular-reads-heading">
        <div className="card-body p-0">
          <div className="px-3 pt-3"><h2 id="popular-reads-heading" className="h6 text-uppercase text-muted m-0">Popular Reads</h2></div>
          <ul className="list-group list-group-flush">
            {POPULAR.map((p) => (
              <li key={p.to} className="list-group-item">
                <NavLink exact to={p.to} className="stretched-link text-decoration-none">
                  {p.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Quick Topics */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Topics</h2>
          <div className="d-flex flex-wrap gap-2">
            {TOPICS.map((t) => (
              <button
                key={t}
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => onTopicClick(t)}
                aria-label={`Search for ${t}`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-2">Get new posts</h2>
          <p className="small text-muted">One email a month. No spam.</p>
          <form className="d-flex gap-2" onSubmit={(e) => e.preventDefault()} aria-label="Newsletter sign up">
            <input type="email" required className="form-control form-control-sm" placeholder="you@example.com" aria-label="Email address" />
            <button className="btn btn-dark btn-sm" type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Sponsored */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-3">Sponsored</h2>
          <AdSlot adSlot="5201219465" />
          <div className="small text-muted">Ads help keep content free.</div>
        </div>
      </div>

      {/* Contact / Write for us */}
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h2 className="h6 text-uppercase text-muted mb-2">Write for us</h2>
          <p className="small text-muted mb-3">Have a great tutorial or case study? Pitch us your draft and reach thousands of developers.</p>
          <NavLink exact to="/contactUs" className="btn btn-outline-primary btn-sm w-100">Contact the editors</NavLink>
        </div>
      </div>
    </aside>
  );
}

export default withRouter(BlogSideBarRight);
